import { React, useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Layout from './components/Layout';
import { Login } from './components/Login/Login';
import { Login2fa } from './components/Login/Login2fa';
import { UserProvider } from './contexts/UserContext';
import { ConfigProvider } from './contexts/ConfigContext';
import './custom.css';
import { ControlCentreProvider } from './contexts/ControlCentreContext';
import i18n from './i18n';
import ProtectedRoute from './components/ProtectedRoute';

export default function App() {

    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        i18n.on('initialized', () => setIsLoaded(true));
    }, []);

    if (!isLoaded) return <p>Loading...</p>;

  return (
    <UserProvider>
        <ConfigProvider>
            <ControlCentreProvider>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/login2fa" element={<Login2fa />} />
                    <Route element={<Layout />}>
                        <Route element={<ProtectedRoute />}>
                        {AppRoutes.map((route, index) => {
                            const { element, ...rest } = route;
                        return <Route key={index} {...rest} element={element} />;
                        })}
                        </Route>
                    </Route>
                </Routes>
            </ControlCentreProvider>
        </ConfigProvider>
    </UserProvider>
  );
}
